module.exports = __webpack_public_path__ + "fecf804ee9bf2f96e6a287d14ac45c87.png";